import { Check, Loader2 } from "lucide-react";

/**
 * SaveStatus — kompakte Auto-Save-Rückmeldung („Speichert…" / „Gespeichert ✓").
 * Wird neben Formular-Überschriften platziert (kein expliziter Speichern-Button mehr).
 */
export default function SaveStatus({ saving, savedAt, className = "" }) {
    if (saving) {
        return (
            <span className={`inline-flex items-center gap-1 text-[11px] font-bold text-gray-500 ${className}`} data-testid="autosave-status">
                <Loader2 className="w-3 h-3 animate-spin" /> Speichert…
            </span>
        );
    }
    if (savedAt) {
        return (
            <span className={`inline-flex items-center gap-1 text-[11px] font-bold text-green-600 ${className}`} data-testid="autosave-status">
                <Check className="w-3 h-3" /> Gespeichert
            </span>
        );
    }
    return (
        <span className={`text-[11px] text-gray-400 ${className}`} data-testid="autosave-hint">
            Automatisch gespeichert
        </span>
    );
}
